/**
 * Interaction blocker function, this will block/unblock any action with the cart in Cart page.
 * @param {boolean} block - enable/disable interaction with the cart
 * @returns void - find a HTML node and add a className called .blocked
 */
export default function (block = false) {
  // Interaction blockers: block interaction with cart
  if (block) {
    document.querySelector('.Cart-items-section')?.classList.add('blocked');
    document.querySelector('.Cart-totals-section')?.classList.add('blocked');
    document.querySelector('.Cart-recs-section')?.classList.add('blocked');
    return;
  }
  // Interaction blockers: unblock interaction with cart
  document.querySelector('.Cart-items-section')?.classList.remove('blocked');
  document.querySelector('.Cart-totals-section')?.classList.remove('blocked');
  document.querySelector('.Cart-recs-section')?.classList.remove('blocked');
  return;
}
